// extracted by mini-css-extract-plugin
export var orderSummary = "_r7-0";
export var showMoreLessButton = "_r7-1";